import { render } from "./ResetPassword.vue?vue&type=template&id=3d1229e8&scoped=true"
import script from "./ResetPassword.js?vue&type=script&lang=js"
export * from "./ResetPassword.js?vue&type=script&lang=js"

import "../login/Login.scss?vue&type=style&index=0&id=3d1229e8&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d1229e8"]])

export default __exports__